import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useRouting } from '~/routing/useRouting';
import { setDocumentTitle } from '~/utils/dom';

import { getRoutes } from './routes';
import { findMatchingRoute } from './utils';

export const useBrowserTitle = () => {
  const { location } = useRouting();
  const intl = useIntl();
  const routes = getRoutes(intl);
  useEffect(() => {
    const route = findMatchingRoute(routes, location.pathname);

    if (route) {
      setDocumentTitle(route.title);
    }

    return () => setDocumentTitle();
  }, [location]);
};
